import useAddToken from "../hooks/useAddToken";

export default function CallbackPage() {
    useAddToken()
    return <>
        Callback!
    </>
}